(function () {
    angular.module('app')
        .factory('helper', helper);
    helper.$inject = ['$window'];
    function helper($window) {
        return {
            getMediaQueries: getMediaQueries,
            getMediaQuery: getMediaQuery,
            getLoadingIndicator: getLoadingIndicator,
            getCurrentMediaQuery: getCurrentMediaQuery
        };

        function getMediaQueries() {
            var queries = angular.element('meta.foundation-mq').css('fontFamily').replace('"', '').replace("'", '').split('&');
            var mediaQueries = {};
            for (var i = 0; i < queries.length; i++) {
                var pieces = queries[i].split('=');
                var key = pieces[0];
                var size = parseFloat(pieces[1]);
                mediaQueries[key] = $window.matchMedia('only screen and (min-width: ' + size + 'em)');
                mediaQueries[key + ' down'] = $window.matchMedia('only screen and (max-width: ' + size + 'em)');
                var nextSize;
                if (i < queries.length - 1) {
                    var nextPieces = queries[i + 1].split('=');
                    var query = 'only screen and ';
                    if (size) {
                        query += '(min-width: ' + size + 'em) and ';
                    }
                    query += '(max-width: ' + parseFloat(nextPieces[1]) + 'em';
                    mediaQueries[key + ' only'] = $window.matchMedia(query);
                }
            }
            return mediaQueries;
        }

        function getMediaQuery(key) {
            var mediaQueries = getMediaQueries();
            return mediaQueries[key];
        }

        function getLoadingIndicator() {
            return angular.element('<span class="fa fa-spin fa-spinner loader"></span>');
        }

        function getCurrentMediaQuery() {
            if (Foundation.MediaQuery.current) {
                return Foundation.MediaQuery.current;
            }
            var queries = getMediaQueries();
            var keys = Object.keys(queries);
            var result;
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (queries[key].matches) {
                    result = key;
                }
                else {
                    break;
                }
            }
            return result;
        }
    }
})();